import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    baseURL: 'https://code64.net.tr/BakApp',
    removeTitle: 'Uyarı!',
    removeMessage: 'Kayıt kalıcı olarak silinecektir! Devam etmek istiyor musunuz?',
    removeConfirm: 'Devam Et',
    removeCancel: 'Vazgeç',
    removeResultTitle: 'İşlem Başarılı!',
    removeResultMessage: 'Kayıt kalıcı olarak silinmiştir.!',
    removeResultClose: 'Kapat',
    requireTitle: 'Uyarı!',
    requireWarning: 'Lütfen zorunlu alanları doldurun.!',
    saveSuccessTitle: 'İşlem Başarılı!',
    saveSuccessMessage: 'İşlem başarılı veri başarıyla kaydedildi.',
    saveErrorTitle: 'İşlem Hatası!',
    saveErrorMessage: 'İşlem hatası! Lütfen tekrar deneyiniz.',
    removeSuccessTitle: 'İşlem Başarılı!',
    removeSuccessMessage: 'İşlem başarılı veri başarıyla silindi.',
    removeErrorTitle: 'İşlem Hatası!',
    removeErrorMessage: 'İşlem hatası! Lütfen tekrar deneyiniz.',
    perPage: 25,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {},
}
